import { useCanEditAuditRoles } from "PFApp/activities/hooks/use_can_edit_audit_roles";
import { useGrowlStoreActions } from "PFApp/stores/growl_store";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";

import { useActivityFormStore } from "../activity_form_store";

export const EnsureRoleEditPermission = ({ redirectTo = "/", children }) => {
  const { t } = useTranslation("activities");
  const { showGrowl } = useGrowlStoreActions();

  const activity = useActivityFormStore((state) => state.activity);
  const { isAudit, isRole, isEdit } = useActivityFormStore((state) => state.activityStatus);

  const { canEditAuditRole } = useCanEditAuditRoles({
    coowned: activity.coowned,
    templateId: activity.template_id,
    workflowState: activity.workflow_state
  });

  const isAuditRole = isAudit && isRole;

  const isEditRegularRolesEnabled = !isAuditRole && activity.coowned;
  const isEditEnabled = isEditRegularRolesEnabled || canEditAuditRole;

  if (isEdit && isRole && !isEditEnabled) {
    showGrowl({
      kind: "error",
      message: t("form.permissions.insufficientEditPermissions")
    });
    return <Navigate to={redirectTo} replace />;
  }

  return children;
};
